import { useEffect } from "react";

import { useFeatureFlag } from "@/components/FeatureFlagProvider";
import { useCurrentConversationId } from "@/hooks/conversation";
import {
  type ConsentKind,
  PRE_ASYNC_COLLECTION_FLAG,
  useMedicationHistoryStore,
} from "@/store/medicationHistory";

export default function MedicationHistoryGate({
  content,
  conversationId: eventConversationId,
  id,
}: {
  content?: { consent_type?: ConsentKind };
  conversationId?: string;
  id?: string;
}) {
  const urlConversationId = useCurrentConversationId();
  const conversationId = eventConversationId ?? urlConversationId;
  const { value: enabled } = useFeatureFlag(PRE_ASYNC_COLLECTION_FLAG, false);
  const start = useMedicationHistoryStore((s) => s.start);

  const consentType = content?.consent_type ?? "surescripts_consent";

  useEffect(() => {
    if (enabled && conversationId && id) {
      start(conversationId, consentType, id);
    }
  }, [enabled, conversationId, id, consentType, start]);

  return null;
}
